/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Directive, Input } from "@angular/core";
import { UiAutoSizeType } from "@webapp/ui/input/input.models";
import { NzAutosizeDirective } from "ng-zorro-antd/input";

@Directive({
  selector: "textarea[uiAutosize]",
  exportAs: "uiAutosize",
})
export class UiAutosizeDirective extends NzAutosizeDirective {
  @Input("uiAutosize")
  public set uiAutosize(value: string | boolean | UiAutoSizeType) {
    super.nzAutosize = value;
  }
}
